
<template>
  <div class="has-text-left">

    <div
      class="modal small"
      :class="{ 'is-active': updateMessage.modalActive }"
      id="cryptoBlockModal"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <button
            class="delete custom-delete"
            @click="updateMessage.modalActive = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="content has-text-left">
            <p>{{$t('payneteasy_note_text')}}</p>
          </div>
        </section>
      </div>
    </div>

    <h5 class="title">{{$t("please_enter_amount")}}</h5>

    <div class="field has-addons">
      <p class="control">
        <a class="button is-static">{{currencySymbols[User.wallet.currency].symbol}}</a>
      </p>
      <p class="control">
        <input
          v-validate="'required|currency|min_value:1'"
          :class="{'input': true, 'is-danger': errors.has('amount') }"
          name="amount"
          type="text"
          :data-vv-as="translations.text.amount"
          :placeholder="translations.text.amount"
          v-model="amount"
        />
        <span
          v-show="errors.has('amount')"
          class="help is-danger"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{ errors.first('amount') }}</span>
      </p>
      <p class="control">
        <a
          class="button is-success"
          @click="deposit"
        >
          <span class="icon is-small">
            <i
              class="fa fa-check"
              :class="{'ml-10': Language == 'fa' || Language == 'ar'}"
            ></i>
          </span>
          <span>{{$t("deposit").tTitle()}}</span>
        </a>
      </p>
    </div>

    <p class="subtitle">{{$t("provider_redirect", {provider: 'Payneteasy'})}}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '../../../config'

export default {
  data() {
    return {
      countries: config.countries,
      amount: 0,
      country: '',
      translations: {
        text: {
          amount: this.$t('amount'),
        },
      },
      currencySymbols: config.currencies,
      updateMessage: {
        modalActive: false,
      },
    }
  },
  // watch: {},
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {
    if (typeof this.User.info.country_code !== 'undefined' && this.User.info.country_code !== '') {
      this.country = this.User.info.country_code
    }
  },
  methods: {
    deposit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return false
        }

        let depositArgs = {
          amount: String(this.amount),
          userID: this.$store.state.user.info.ID,
        }

        this.$bus.$emit('RequestDeposit', '/finance/deposit/payneteasy', depositArgs, response => {
          if (response.data.success) {
            window.location.replace(response.data.redirectURL)
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// Payneteasy.vue?15fea75d